import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import TransactionList from "@/modules/recognition/admin/components/TransactionList";
import { fetchTransactionsQueryOptions } from "@/modules/recognition/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_recognition/recognition/transactions/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "recognition.recognition-transaction.view",
    );

    return {
      crumb: [
        {
          label: context.t("Appreciation History", { ns: "recognition.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchTransactionsQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("recognition.admin");
  return (
    <Container title={t("Appreciation History")}>
      <TransactionList />
    </Container>
  );
}
